module.exports = __webpack_public_path__ + "dee763c06d6434d90f3778eb1e2432a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jufangerheyi.png
// module id = 175
// module chunks = 1